import React from "react";
import { Checkbox } from "antd";
import FormulaRenderer from "../../../../../../../math-formula";

function ChooseMultiText({ data }: any) {
return (
    <div>
      {data?.questions &&
        data?.questions?.length > 0 &&
        data?.questions?.map((quiz: any, index: any) => (
          <div
            key={quiz?.uuid + index}
            className={`mb-12 ${quiz?.isTrue && "choose-correct"}`}
          >
            <Checkbox disabled={true} checked={quiz?.isTrue}>
              <div
                className={`font-size-16 line-height-24 font-weight-5 ${
                  quiz?.isTrue && "text-result"
                }`}
              >
                <FormulaRenderer
                  className="ml-1"
                  htmlString={quiz?.content || "N/A"}
                />
              </div>
            </Checkbox>
          </div>
        ))}
    </div>
  );
}

export default ChooseMultiText;
